//
// Gallery JS
//

import Isotope from "isotope-layout";

export const initGallery = () => {
  document.querySelectorAll(".gallery-items").forEach((grid) => {
    if (grid.__isotope) {
      grid.__isotope.destroy();
      grid.__isotope = null;
    }

    grid.__isotope = new Isotope(grid, {
      itemSelector: ".gallery-item",
      layoutMode: "packery",
    });
  });
};

initGallery();
